<template>
    <div class="sos-num">
        <van-nav-bar title="SOS设置" left-text="返回" fixed :border="false" left-arrow @click-left="backPage" />
        <p class="sos-title">可在此设置三个SOS号码，使用设备的家人在进行一键求助时设备会依次给所设置的手机号拨打电话</p>
        <div class="sos-box" v-for="(item,index) in sosNum" :key="index">
            <div class="sos-flex">
                <p>SOS号码{{index+1}}</p>
                <van-field
                v-model="item.phone"
                placeholder="请填写手机号码"
                :border="false"
                :maxlength="11"
                type="number"
                />
                <img class="sos-img" src="@/assets/images/family_number.png" background-size="cover" @click="showAddress(index)" />
            </div>
        </div>
        <div class="btn-box">
            <van-button round type="info" @click="save">保存</van-button>
        </div>
        <van-popup v-model="show" position="bottom" closeable round @close="close">
            <div class="pop-content">
                <span class="device-title">通讯录</span>
                <div class="auto-box">
                    <div class="no-data-center" v-if="deviceList.length<=0">
                    通讯录暂无号码
                    </div>
                    <template v-else>
                    <div class="device-information" v-for="(item,index) in deviceList" :key="index" @click="checkThis(item)">
                        <div class="device-name">
                        <img class="information-img" src="@/assets/images/morentouxiangbeifen.png" background-size="cover" />
                        <p>{{item.name}}</p>
                        </div>
                        <div class="device-phone">
                        <p>{{item.sim}}</p>
                        </div>
                    </div>
                    </template>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="frequentFlag" round @close="close">
            <div class="fill-number">
                <img class="fill-img" src="@/assets/images/address_list.png" background-size="cover" />
                <p>提示</p>
                <span>通讯录为空，请先添加常用联系人</span>
                <div class="fill-btn">
                <van-button @click="close" class="fill-cancel" type="primary">取消</van-button>
                <van-button class="fill-confirm" type="primary" @click="goAddress">确定</van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    data() {
        return {
            nameValue:'',//名称
            iphoneValue:'',//电话号码
            sosNum:[
                {
                phone:''
                },
                {
                phone:''
                },
                {
                phone:''
                }
            ],
            show:false,//通讯录
            flag:false,//显示通讯录or提示
            frequentFlag:false,//无联系人提示
            updateIndex:null,//修改的联系人是哪一个
            deviceList:[
                {
                name:'ddd',
                sim:'454454545'
                }
            ],//通讯录列表
        };
    },

    created() {
        this.getSupportList()
        this.close()
    },
    methods: {
        /**
         * 获取设备支持的指令列表
         */
        getSupportList(){
          let data = {
            ver:1,
            method:'getDeviceAllInfo'
          }
          this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
              if (res.code === 0) {
                this.$store.commit('set_devTypeList', JSON.stringify(res.data.instructionList))
                this.getsosNum()
                this.getAddressList()
              } else {
                wx.showToast({
                  title: res.msg,
                  icon: "none"
                });
              }
          })
        },
        close(){
            this.frequentFlag = false
            this.show = false
        },
        /**
         * 打开通讯录
         */
        showAddress(index){
        this.updateIndex = index
        if(this.flag){
            this.frequentFlag = true
        }else{
            this.show = true
        }
        },
        /**
         * 点击通讯录
         */
        checkThis(item){
            this.sosNum[this.updateIndex].phone =  item.sim
            this.show = false
        },
        /**
         * 增加通讯录
         */
        goAddress(){
            this.$router.push({ name: 'addMail'});
        },
        /**
         *获取白名单列表
        */
        getAddressList(){
        let data = {
            ver:1,
            method:'getInstructById',
            instructionId:this.$intfilter.instructFilter('白名单')
        }
        this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
            if (res.code === 0) {
                this.deviceList = []
                if(res.data.params===""){
                this.flag = true
                return
                }else{
                this.flag = false
                }
                let arr = res.data.params.split(',')
                for (let i = 0; i < arr.length/2; i++) {
                this.deviceList.push({
                    name:arr[i*2],
                    sim:arr[i*2+1]
                })
                }
            } else {
                this.$toast({
                    message: res.msg,
                    duration: 2000,
                    icon: require('@/assets/images/safety-fence/wrong.png'),
                });
            }
        })
        },
        /**
         * 获取sos列表
         */
        getsosNum(){
        let data = {
            ver:1,
            method:'getInstructById',
            instructionId:this.$intfilter.instructFilter('SOS号码')
        }
        this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
            if (res.code === 0) {
              console.log(77)
                let arr = res.data.params.split(',')
                for (let i = 0; i < arr.length; i++) {
                this.sosNum[i].phone = arr[i]
                }
            } else {
                this.$toast({
                    message: res.msg,
                    duration: 2000,
                    icon: require('@/assets/images/safety-fence/wrong.png'),
                });
            }
        })
        },
        /**
         * 保存sos
         */
        save(){
            let flag = false,str='';
            this.sosNum.forEach((item,index) => {
                str+=(item.phone+',')
                if(item.phone.length<=0){
                    this.sosNum[index].phone = ''
                    this.$forceUpdate();//改变的数据是多层级的，没有触发render函数进行自动更新，需要在数据改变以后手动调用
                }
                if(item.phone.length<1 || item.phone.length>1)return
                flag = true;
            });
            if(flag){
                this.$toast("请输入正确的手机号码")
                return
            }
            let data = {
                ver:1,
                method:'sendInstruct',
                params:str,
                instructionId:this.$intfilter.instructFilter('SOS号码')
            }
            this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
                if (res.code === 0) {
                    this.$toast({
                        message: "保存成功",
                        duration: 2000,
                        icon: require('@/assets/images/safety-fence/correct.png'),
                    });
                    let timer = setTimeout(()=>{
                        that.getsosNum()
                        clearTimeout(timer)
                    },1000)
                } else {
                    this.$toast({
                        message: res.msg,
                        duration: 2000,
                        icon: require('@/assets/images/safety-fence/wrong.png'),
                    });
                }
            })
        },
        /**
         * 返回上一次路由
         */
        backPage() {
            this.$router.back(-1);
        },
    },

    watch: {
    }
};
</script>

<style lang="scss" scoped>
.sos-num{
  background: #f8f8f8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 40px 0;
}
.sos-title{
  margin-top: 60px;
  font-size: 26px;
  font-weight: 400;
  color: #666666;
}
.sos-box{
  margin-top: 40px;
  width: 686px;
  height: 116px;
  background: #FFFFFF;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.sos-flex{
  display: flex;
  align-items: center;
}
.sos-flex>p{
  width: 260px;
  margin-left: 32px;
  font-size: 30px;
  font-weight: 600;
  color: #666666;
}
.sos-img{
  width: 32px;
  height: 32px;
  margin: 0 32px;
}
.pop-content{
  background-color: #fff;
  position: relative;
}
.pop-content .device-title{
  font-size: 34px;
  font-weight: 600;
  color: #111;
  display: flex;
  justify-content: center;
  padding: 40px 0 60px 0;
}
.auto-box{
  height: 400px;
  overflow: auto;
}
.no-data-center{
  line-height: 400px;
  text-align: center;
}
.pop-content  .device-information{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  padding: 0 60px;
  margin-bottom: 40px;
}
.device-information .device-name{
  display: flex;
  align-items: center;
  font-size: 28px;
}
.device-information .device-name .information-img{
  width: 80px;
  height: 80px;
  margin-right: 20px;
}
.device-information .device-phone{
  font-size: 28px;
  display: flex;
  align-items: center;
  color: #999999;
}
.device-information .device-phone .information-img{
  width: 46px;
  height: 46px;
  margin-left: 30px;
}
.fill-number{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 42px 32px 32px;
}
.fill-number>p{
  margin: 40px 0 3px;
  font-size: 36px;
  font-weight: 600;
  color: #111111;
}
.fill-number>span{
  margin: 30px 0 10px;
  font-size: 26px;
  font-weight: 400;
  color: #666666;
}
.fill-number .fill-img{
  width: 356px;
  height: 192px;
}
.fill-number .fill-btn{
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.btn-box{
  z-index: 1;
  position: fixed;
  width: 100%;
  padding: 20px 0 50px;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f8f8;
}
</style>
<style lang="scss">
.sos-num .van-button{
  margin: 0 auto;
  border: none;
  width: 586px;
  height: 98px;
  background-color: #01ADA9;
}
.sos-num ._van-field{
  flex: 1;
  color: #111111;
  font-size: 30px;
}
.sos-num .fill-number .van-button{
  width: 200px;
  height: 68px;
}
.sos-num .fill-number .fill-cancel{
  margin-right: 36px;
  background: #FFFFFF;
  border-radius: 34px;
  color: #01ADA9;
  border: 2px solid #01ADA9;  
}
.sos-num .fill-number .fill-confirm{
  background: #01ADA9;
  border-radius: 34px;
  border: 2px solid #01ADA9;
  color: #fff;
}
.sos-num .fill-number .van-field__control{
  text-align: center;
}
.sos-num{
    .van-nav-bar{
        background-color: #F8F8F8;
        width: 100%;
    }
}
</style>

